import { render, staticRenderFns } from "./app.vue?vue&type=template&id=4d7dbf72&scoped=true&lang=pug"
import script from "./app.vue?vue&type=script&lang=ts"
export * from "./app.vue?vue&type=script&lang=ts"
import style0 from "./app.vue?vue&type=style&index=0&id=4d7dbf72&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7dbf72",
  null
  
)

export default component.exports